// @flow

import { createContext, useContext } from 'react'

export const OpenPanelContext: any = createContext()

export const useOpenPanelAnalytics = () => useContext(OpenPanelContext)

export default OpenPanelContext
